// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3kL4q","topBottomGutter":"Layout_topBottomGutter__fltkL"};